import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3458cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-user-form",
  "data-bs-theme": "light"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create New User", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_13 = ["type"]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "showPassword",
  class: "col"
}, "Show Password", -1))
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dateOfJoining" }, "Date of Joining", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "row form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "isSuperuser",
  class: "col"
}, [
  /*#__PURE__*/_createTextVNode("Is Admin? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Designates that this user has all permissions without explicitly assigning them.")
], -1))
const _hoisted_21 = { class: "row form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "isStaff",
  class: "col"
}, [
  /*#__PURE__*/_createTextVNode("Is Manager? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Designates the user as Manager(Manager is able to create,view,edit and delete jobs, tasks).")
], -1))
const _hoisted_23 = { class: "row form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "isActive",
  class: "col"
}, [
  /*#__PURE__*/_createTextVNode("Is Active? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Designates whether this user should be treated as active. Unselect this instead of deleting accounts")
], -1))
const _hoisted_25 = { class: "row form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col inline-label" }, [
  /*#__PURE__*/_createTextVNode("Do you want to add this user as an employee? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, " User as an employee means whether this user is going to be employed and going to have a certain hourly pay ")
], -1))
const _hoisted_27 = { class: "col-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yes" }, "Yes", -1))
const _hoisted_29 = { class: "col-1" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "no" }, "No", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "workCenter" }, "Work Center", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "hourly_pay" }, [
  /*#__PURE__*/_createTextVNode("Hourly Pay "),
  /*#__PURE__*/_createElementVNode("b", null, "($)")
], -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "active" }, "Active", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Create User")
], -1))

import { onMounted, ref } from 'vue';
import { postToUrl } from '@/api/api';
import { useUserStore } from '@/stores/UserStore';
import { User } from '@/types/Ops';
import { WorkCenter } from '@/types/Ops';
import { fetchWorkCenters } from '@/api/api';

interface UserEmployee {
  user: number;
  hourly_pay: number;
  workCenterId: number;
  active: boolean;
}

interface UserResponse {
  id?: number;
  username: string;
  password: string;
  first_name: string;
  last_name: string;
  email: string;
  is_superuser: boolean;
  is_staff: boolean;
  is_active: boolean;
  date_joined: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateUser',
  setup(__props) {

const user = ref<User>({
  // Initial user data
  username: '',
  password: '',
  first_name: '',
  last_name: '',
  email: '',
  is_superuser: false,
  is_staff: false,
  is_active: true,
  date_joined: ''
});
const selectedWorkCenterId = ref<number | null>(null);
const showPassword = ref(false);
const addAsEmployee = ref<string>('');
const employee = ref<UserEmployee>({
  // Initial employee data
  user: 0,
  hourly_pay: 0,
  workCenterId: 0,
  active: false
});
const workCenters = ref<WorkCenter[]>([]);

const resetUserData = () => {
  user.value = {
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    email: '',
    is_superuser: false,
    is_staff: false,
    is_active: true,
    date_joined: ''
  };
  addAsEmployee.value = '';
  selectedWorkCenterId.value = null;
  employee.value = {
    user: 0,
    hourly_pay: 0,
    workCenterId: 0,
    active: false
  };
};

onMounted(async () => {
  workCenters.value = await fetchWorkCenters();
});

const createUser = async () => {
  // console.log('Attempting to create user with data:', user.value);
  try {
    console.log('Sending request to backend...');
    const userResponse = await postToUrl('/ops/api/Createuser/', user.value) as UserResponse;
    // console.log('Response received:', userResponse);
    if (userResponse && userResponse.id) {
      // console.log('User creation successful with ID:', userResponse.id);
      let employeeData;
      if (addAsEmployee.value === 'yes' && selectedWorkCenterId.value !== null && !isNaN(selectedWorkCenterId.value)) {
        employeeData = {
          user: userResponse.id,
          hourly_pay: employee.value.hourly_pay,
          active: employee.value.active,
          work_centers: [Number(selectedWorkCenterId.value)]
        };
      } else {
        employeeData = {
          user: userResponse.id,
          workCenterId: null,
          hourly_pay: null,
          active: null,
          work_centers: []
        };
      }
      const employeeResponse = await postToUrl('/ops/api/create_user_employee/', employeeData);
      if (employeeResponse) {
        console.log('Employee data processed successfully.');
        alert('User and employee data processed successfully!');
      } else {
        console.error('Failed to process employee data:', employeeResponse);
        alert('Failed to process employee data. Please check the details.');
      }
    } else {
      console.error('User creation failed with response:', userResponse);
      alert("Failed to create user. Please check the provided data.");
    }
  } catch (error) {
    console.error('Error creating user:', error);
    alert("Failed to create user. Error: " + error.message);
  } finally {
    resetUserData();
  }
};


const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _withModifiers(createUser, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "firstName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.first_name) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, user.value.first_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "lastName",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.last_name) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, user.value.last_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          id: "email",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.email) = $event)),
          type: "email",
          required: ""
        }, null, 512), [
          [_vModelText, user.value.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          id: "username",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.username) = $event)),
          type: "text",
          required: ""
        }, null, 512), [
          [_vModelText, user.value.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: showPassword.value ? 'text' : 'password',
          id: "password",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.password) = $event)),
          required: ""
        }, null, 8, _hoisted_13), [
          [_vModelDynamic, user.value.password]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "showPassword",
            class: "col-1 form-check-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showPassword).value = $event))
          }, null, 512), [
            [_vModelCheckbox, showPassword.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          id: "dateOfJoining",
          class: "form-control",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.date_joined) = $event)),
          type: "date",
          required: ""
        }, null, 512), [
          [_vModelText, user.value.date_joined]
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          id: "isSuperuser",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.is_superuser) = $event)),
          class: "col-1 form-check-input",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, user.value.is_superuser]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _withDirectives(_createElementVNode("input", {
          id: "isStaff",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((user.value.is_staff) = $event)),
          class: "col-1 form-check-input",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, user.value.is_staff]
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _withDirectives(_createElementVNode("input", {
          id: "isActive",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((user.value.is_active) = $event)),
          class: "col-1 form-check-input",
          type: "checkbox",
          required: ""
        }, null, 512), [
          [_vModelCheckbox, user.value.is_active]
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "radio",
            id: "yes",
            value: "yes",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addAsEmployee).value = $event))
          }, null, 512), [
            [_vModelRadio, addAsEmployee.value]
          ]),
          _hoisted_28
        ]),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "radio",
            id: "no",
            value: "no",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addAsEmployee).value = $event))
          }, null, 512), [
            [_vModelRadio, addAsEmployee.value]
          ]),
          _hoisted_30
        ])
      ]),
      (addAsEmployee.value === 'yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _withDirectives(_createElementVNode("select", {
                id: "workCenter",
                class: "form-select",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedWorkCenterId).value = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workCenters.value, (workCenter) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: workCenter.id,
                    value: workCenter.id
                  }, _toDisplayString(workCenter.name), 9, _hoisted_34))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedWorkCenterId.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                id: "hourly_pay",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((employee.value.hourly_pay) = $event)),
                type: "number",
                required: ""
              }, null, 512), [
                [_vModelText, employee.value.hourly_pay]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                id: "active",
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((employee.value.active) = $event))
              }, null, 512), [
                [_vModelCheckbox, employee.value.active]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_39
    ], 32)
  ]))
}
}

})